module.exports = __webpack_public_path__ + "img/feather.90f969db.svg";